import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { NavLink } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { addItem } from '../redux/actions';

function Product() {

    const { id } = useParams();
    const [product, setProduct] = useState([]);
    const [loading, setLoading] = useState(false);

    const distpatch = useDispatch();
    const addProduct = (product) => {
        distpatch(addItem(product));
    }



    useEffect(() => {
        const getProducts = async () => {
            setLoading(true);
            const response = await fetch(`https://fakestoreapi.com/products/${id}`);
            setProduct(await response.json());
            setLoading(false);


        }

        getProducts();
    }, []);

    const Loading = () => {
        return (
            <>

                <div class="main">
                    <div id="firstDot"></div>
                    <div id="secondDot"></div>
                    <div id="thirdDot"></div>
                    <div id="fourthDot"></div>
                </div>
            </>
        )

    }

    const ShowProduct = () => {
        return (
            <>
                <div className="Productttti col-md-6 justify-content-center">
                    <div class="card carddd h-100 text-center justify-content-center p-4 " >
                        <img src={product.image} alt={product.title} height="500px" />
                    </div>
                </div>

                <div className="Productttt col-md-6">
                    <h4 className="text-uppercase text-black-50">
                        {product.category}

                    </h4>
                    <h1 className="Productttt display-6">{product.title}</h1>
                    <p className="lead fw-bolder">
                        Rating {product.rating && product.rating.rate}
                        <i className="fa fa-star"></i>
                    </p>
                    <h3 className="Productttt display-6 fw-bold my-4">
                        $ {product.price}
                    </h3>
                    <p className="lead Productttt">{product.description}</p>
                    <button className="btn btn-outline-dark px-4 py-2"
                        onClick={() => addProduct(product)}>
                        Add to Cart
                    </button>
                    <NavLink to="/cart" className="Productttt btn btn-dark ms-2 px-3 py-2" >
                        Go to Cartt
                    </NavLink>
                </div>
            </>
        )
    }
    return (
        <div>
            <div className="container py-5">
                <div className="row py-5">
                    {loading ? <Loading /> : <ShowProduct />}
                </div>
            </div>
        </div>
    );
}

export default Product;